import ContactSection from '@/components/sections/contact/ContactSection'
import PageHero from '@/components/sections/shared/PageHero'
import { useData } from '@/hooks/useLocale'
import { useTitle } from '@/hooks/useTitle'

/** The contact page: a photo hero, then the demo-request form. */
export default function ContactPage() {
  const { CONTACT } = useData()
  useTitle(CONTACT.eyebrow)

  return (
    <>
      <PageHero
        eyebrow={CONTACT.eyebrow}
        title={CONTACT.title}
        text={CONTACT.text}
      />
      <ContactSection />
    </>
  )
}
